import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Upload from '../../../components/form/upload/Upload';
import { SIZE_5MB } from '../../../core/constants/file';
import ProjectDocumentsService, { UploadConfig } from '../../../core/services/ProjectDocumentsService';
import { RootState } from '../../../core/state/state';
import { FileDetailsModel } from '../../../components/form/upload/file-details/FileDetails';
import { getProjectDetails } from '../../../core/state/project/asyncActions';
import { spawnGlobalNotification } from '../../../core/state/global-notifications/asyncActions';
import { GlobalNotificationTypes } from '../../../core/enums/GlobalNotificationTypes';

const ProjectInfoPictureUpload: React.FC = () => {
  const { t } = useTranslation();
  const IMAGE_ACCEPTED = 'image/jpeg, image/png, image/jpg, image/bpm';
  const { projectId } = useParams<{ projectId: string }>();
  const projectDetails = useSelector((state: RootState) => state.projects?.projectDetails);
  const dispatch = useDispatch();

  const fileDetails: FileDetailsModel = {
    id: Number(projectDetails?.image.id),
    filename: String(projectDetails?.image.name),
    location: String(projectDetails?.image.name),
    uploadedAt: String(projectDetails?.image.createdOn),
    uploadedBy: String(projectDetails?.image.createdBy)
  };

  return (
    <>
      <Upload
        accept={IMAGE_ACCEPTED}
        options={{
          maxSize: SIZE_5MB
        }}
        messages={{
          fileTooLarge: t('file.sizeValidation.projectPicture'),
          fileInvalidType: t('file.typeValidation.projectPicture')
        }}
        onDrop={async (formData: FormData, config: UploadConfig) => {
          await ProjectDocumentsService.uploadProjectDocument(Number(projectId), Number(projectDetails?.image.id), formData, config);
          dispatch(getProjectDetails(Number(projectId)));
          dispatch(
            spawnGlobalNotification({
              type: GlobalNotificationTypes.Success,
              title: t('projectSettings.notification.image.title'),
              message: t('projectSettings.notification.image.content')
            })
          );
        }}
        onRemove={async () => {
          await ProjectDocumentsService.setDefaultProjectImage(Number(projectId), Number(projectDetails?.image.id));
          dispatch(
            spawnGlobalNotification({
              type: GlobalNotificationTypes.Info,
              title: t('projectSettings.notification.image.remove.title'),
              message: t('projectSettings.notification.image.remove.content')
            })
          );
          dispatch(getProjectDetails(Number(projectId)));
        }}
        fileDetails={projectDetails?.image.id ? [fileDetails] : undefined}
        confirmModal={{
          titleText: t('projectSettings.modal.image.title'),
          contentText: t('projectSettings.modal.image.content')
        }}
        removeModal={{
          titleText: t('projectSettings.modal.image.remove.title'),
          contentText: t('projectSettings.modal.image.remove.content')
        }}
      />
    </>
  );
};

export default ProjectInfoPictureUpload;
